import { taskService } from "@miplatform/api";
import { useComponentState } from "@miplatform/hooks";
import {
  IApiRequest,
  ICreateDailyUserCapacityRequest,
  ICreateDefaultUserCapacityRequest,
} from "@miplatform/types";
import { createUUID } from "@miplatform/utils";

const getUserCapacitiesUUID = createUUID();
const updateUserCapacitiesDefaultUUID = createUUID();
const updateUserCapacitiesDailyUUID = createUUID();

export const useUserCapacities = () => {
  const stateManager = useComponentState();

  const getUserCapacities = ({ id, signal }: IApiRequest = {}) => {
    stateManager.abort(getUserCapacitiesUUID);
    return stateManager.run(
      async () =>
        taskService.userCapacities.getDefaultsForCalendarSet({
          id,
          signal,
        }),
      getUserCapacitiesUUID
    );
  };

  const updateDefaultUserCapacities = (
    data: ICreateDefaultUserCapacityRequest
  ) => {
    stateManager.abort(updateUserCapacitiesDefaultUUID);
    return stateManager.run(
      async () =>
        taskService.userCapacities.updateDefault({
          data,
        }),
      updateUserCapacitiesDefaultUUID
    );
  };

  const updateDailyUserCapacities = (data: ICreateDailyUserCapacityRequest) => {
    stateManager.abort(updateUserCapacitiesDailyUUID);
    return stateManager.run(
      async () =>
        taskService.userCapacities.updateDaily({
          data,
        }),
      updateUserCapacitiesDailyUUID
    );
  };

  return {
    isLoading: stateManager.isBusy(),
    getUserCapacities,
    updateDefaultUserCapacities,
    updateDailyUserCapacities,
  };
};
